import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  padding-bottom: ${props => props.theme.spacing.sp24};
`

export const DownloadLink = styled.a`
  color: ${props => props.theme.colors.outline.default};
  text-decoration: underline;
`
